import { render } from "./EmergencyContactsSection.vue?vue&type=template&id=30882550&ts=true"
import script from "./EmergencyContactsSection.ts?vue&type=script&lang=ts&external"
export * from "./EmergencyContactsSection.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__